import { pushEventToDataLayer } from '@helpers/dataLayer';
import { formatListGroupData, getFormatListGroupData } from '../helpers/GaHelpers';

export const getListValues = (listTrackingData) => {
    const {
        totalProducts, productsPerPage, currentPage, productIndex, productsGroup, productsPerRow
    } = listTrackingData;
    const column = (productIndex % productsPerRow) + 1;
    const row = Math.floor(productIndex / productsPerRow) + 1;
    const position = ((currentPage * productsPerPage) - productsPerPage) + (((row * productsPerRow) - productsPerRow) + column);
    const formattedData = getFormatListGroupData(
        {
            column,
            currentPage,
            group: productsGroup,
            position,
            productsPerRow,
            productsPerPage,
            row,
            totalProducts
        }
    );

    return formatListGroupData(formattedData, '|');
};

export const pushDataToTracking = (trackingData) => {
    const {
        id, variants, listTrackingData, adId, event: eventName
    } = trackingData;

    const trackingDataToSend = {
        product_id: id,
        variant_id: variants[0].id,
        list: getListValues(listTrackingData),
        kevel_ad_id: adId
    };

    pushEventToDataLayer(eventName, null, trackingDataToSend);
};
